import type { Price } from '@/types/price'

export const mapPrice = (price: Price) => {
  const fixedPrice = price.valuation_rate
    ? (price.valuation_rate * 1.21).toFixed(2).replace('.', ',')
    : 'Error'

  return `€ ${fixedPrice}`
}
